// extracted by mini-css-extract-plugin
export default {"inputBlock":"select_inputBlock__3jGVJ","input":"select_input__+BGSc","label":"select_label__v4o8i","labelTop":"select_labelTop__vK3Uj"};